import { z as a } from "zod";
import { UserIdSchema as r, RefreshTokenSchema as n, UsernameSchema as i } from "../schemas.js";
var t = /* @__PURE__ */ ((e) => (e.SuperAdmin = "SuperAdmin", e.ReadAdmin = "ReadAdmin", e.WriteAdmin = "WriteAdmin", e.ReadAdvert = "ReadAdvert", e.WriteAdvert = "WriteAdvert", e.ReadPublisher = "ReadPublisher", e.WritePublisher = "WritePublisher", e.ReadExchange = "ReadExchange", e.WriteExchange = "WriteExchange", e.SplitTrafficSourceBySsp = "SplitTrafficSourceBySsp", e))(t || {}), d = /* @__PURE__ */ ((e) => (e.Admin = "admin", e.Manager = "manager", e.AdAdmin = "adAdmin", e.Advert = "adAdvertiser", e.Exchange = "adExchange", e.Publisher = "adPublisher", e))(d || {});
const o = a.enum(t), c = a.enum(d), A = a.object({
  userId: r,
  roles: a.array(c).readonly(),
  iat: a.number().optional(),
  exp: a.number().optional()
}).readonly(), p = a.object({
  id: r,
  username: i.optional(),
  title: a.string().min(1).optional(),
  privileges: a.array(o).readonly(),
  refreshToken: n.optional()
}).readonly();
export {
  p as AuthUserSchema,
  A as JwtPayloadSchema,
  t as PrivilegeEnum,
  o as PrivilegeSchema,
  d as UserRoleEnum,
  c as UserRoleSchema
};
//# sourceMappingURL=schemas.js.map
